module.exports = require("@javascript-obfuscator/estraverse");;